import { render, staticRenderFns } from "./TabelaANS.vue?vue&type=template&id=7e3532d4&scoped=true"
import script from "./TabelaANS.vue?vue&type=script&lang=js"
export * from "./TabelaANS.vue?vue&type=script&lang=js"
import style0 from "./TabelaANS.vue?vue&type=style&index=0&id=7e3532d4&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e3532d4",
  null
  
)

export default component.exports